module.exports = __webpack_public_path__ + "static/media/product-request-acces-bar.fc1e98b3.svg";